module.exports = __webpack_public_path__ + "static/mitsolutions.7b0d388d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/img/vendors/mitsolutions.png
// module id = 661
// module chunks = 172845445241205